// The studio module's entire public surface.
//
// Two exports and one stylesheet, following the boundary the engagement and
// dashboard modules already keep (ADR-0016, ADR-0020): nothing outside this
// folder imports from any other file in it, and nothing in here imports from
// `pages/`. Deleting the module is deleting the folder and two lines in
// App.tsx — and Compose keeps working, because it depends on the
// `content_drafts` table and not on this code.

import "./studio.css";

export { Studio } from "./Studio";

/** Where the nav link points. Kept here so callers never hardcode it. */
export const STUDIO_ROUTE = "/studio";
